<template>
  <a-spin :spinning="spinning" :tip="spinningTip">
    <div :class="spinning ? 'spin-content' : ''">
      <a-form>
        <!-- 眼镜设备用户加入公司二维码 -->
        <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
          <a-col :span="12" class="padding-tb-md">
            <h3 class="panle-head" style="margin-bottom:16px">
              {{ $t('userCenter.glassesSettingsTitle') }}
            </h3>
            
            <a-col :span="24">
              <a-form-item :label="$t('userCenter.registerQRCode')">
                <div style="display: flex">
                  <QRCode
                    v-if="codeString"
                    :codeString="codeString"
                    :codeName="setQRCodeTargetFullName"
                    :refreshCodeFunc="getGlassesQRCode"
                  >
                    <template v-slot:describeBottom>
                      <p style="color: #fa8c16;line-height: 1.5">
                        {{ $t('userCenter.QRCodeUseDesc') }}
                      </p>
                      <p style="color: #1890ff;line-height: 1.5">
                        {{ $t('userCenter.QRCodeExpiryTimeDesc') }} {{ expiredTimeString }}
                      </p>
                    </template>
                  </QRCode>
                </div>
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <!-- 同步所有数据导眼镜后台 -->
        <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
          <a-col :span="12" class="padding-tb-md">
            <h3 class="panle-head" style="margin-bottom:16px">
              {{ $t('userCenter.dataSyncTitle') }}
            </h3>

            <a-col :span="24">
              <p style="color: #fa8c16;line-height: 1.5">
                {{ $t('userCenter.syncDataDesc') }}
              </p>
              <a-button type="primary" @click="syncData">
                {{ $t('userCenter.dataSyncBtn') }}            
              </a-button>
            </a-col>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-spin>
</template>

<script>
import QRCode from '@/components/QRCode'
import { getGlassesQRCode, syncDataToClassesDB } from '@/api/userMana'

export default {
  name: 'userCenterGlassesSettings',
  components: {
    QRCode
  },
  data () {
    return {
      spinning: false,
      spinningTip: '',
      // 注册二维码
      setQRCodeTargetFullName: '智能眼镜注册',
      codeString: '',
      expiredTimeString: ''
    }
  },
  computed: {},
  created() {
    this.getGlassesQRCode()
  },
  methods: {
    // 获取二维码
    async getGlassesQRCode() {
      // 加载时遮罩
      this.spinning = true
      this.spinningTip = this.$t('userCenter.QRCodeLoading')

      try {
        const res = await getGlassesQRCode()
        const data = res.data.collection[0]
        this.codeString = data.qrCode
        this.expiredTimeString = data.expiredAt

        this.spinning = false
        this.spinningTip = ''
      } catch (error) {
        this.spinning = false
        this.spinningTip = ''

        this.$notification.error({
          message: this.$t('userCenter.notifyError'),
          description: this.$t('userCenter.getQRCodeError')
        })
      }
    },

    async syncData() {
      // 同步时遮罩
      this.spinning = true
      this.spinningTip = this.$t('userCenter.syncDataWaiting')
      try {
        const res = await syncDataToClassesDB()
        this.spinning = false
        this.spinningTip = ''

        this.$notification.success({
          message: this.$t('userCenter.notifySuccess'),
          description: this.$t('userCenter.syncDataSuccess')
        })
      } catch (error) {
        this.spinning = false
        this.spinningTip = ''

        this.$notification.error({
          message: this.$t('userCenter.notifyError'),
          description: this.$t('userCenter.syncDataError')
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.spin-content {
  // border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  // padding: 30px;
}
</style>
